import { ComplexMetadata, flattenComplexObject } from 'utils/format/object'
import { EventSenderPlugin } from '.'
import { Metadata, SendEventData } from '../types'
import * as amplitude from '@amplitude/analytics-browser'

export class AmplitudePlugin extends EventSenderPlugin {
  constructor() {
    super('Amplitude')
  }

  sendEvent(event: SendEventData) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { error: _, ...metadata } = event.metadata || {}

    const eventProperties = event.metadata
      ? flattenComplexObject(metadata as ComplexMetadata)
      : {}

    amplitude.track(event.label, { ...eventProperties })
  }

  updateUserMetadata(metadata: Metadata) {
    if (metadata.user_id) {
      amplitude.setUserId(metadata.user_id.toString())
    }

    const userProperties = { ...metadata }
    delete userProperties.user_id

    if (Object.keys(userProperties).length > 0) {
      const identify = new amplitude.Identify()

      Object.entries(flattenComplexObject(userProperties)).forEach(
        ([key, value]) => {
          if (value !== undefined && value !== null) {
            identify.set(key, value)
          }
        }
      )
      amplitude.identify(identify)
    }
  }
}
